var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 62,
    viewBox: "0 0 64 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1224_5835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5783 8.79219C31.0367 7.43008 32.9633 7.43009 33.4217 8.79219L37.5786 21.1449C37.921 22.1623 38.8746 22.8475 39.9481 22.8475H53.2469C54.7127 22.8475 55.3083 24.7337 54.1084 25.5755L43.4715 33.0372C42.5644 33.6735 42.1843 34.831 42.5378 35.8812L46.6289 48.0384C47.0909 49.4111 45.5316 50.5766 44.3459 49.7448L33.4357 42.0914C32.574 41.4869 31.426 41.4869 30.5643 42.0914L19.6541 49.7448C18.4684 50.5766 16.9091 49.4111 17.3711 48.0384L21.4622 35.8812C21.8157 34.831 21.4356 33.6735 20.5285 33.0372L9.89163 25.5755C8.69165 24.7337 9.28725 22.8475 10.7531 22.8475H24.0519C25.1254 22.8475 26.079 22.1623 26.4214 21.1449L30.5783 8.79219Z",
    fill: "#F1C555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5783 8.79219C31.0367 7.43008 32.9633 7.43009 33.4217 8.79219L37.5786 21.1449C37.921 22.1623 38.8746 22.8475 39.9481 22.8475H53.2469C54.7127 22.8475 55.3083 24.7337 54.1084 25.5755L43.4715 33.0372C42.5644 33.6735 42.1843 34.831 42.5378 35.8812L46.6289 48.0384C47.0909 49.4111 45.5316 50.5766 44.3459 49.7448L33.4357 42.0914C32.574 41.4869 31.426 41.4869 30.5643 42.0914L19.6541 49.7448C18.4684 50.5766 16.9091 49.4111 17.3711 48.0384L21.4622 35.8812C21.8157 34.831 21.4356 33.6735 20.5285 33.0372L9.89163 25.5755C8.69165 24.7337 9.28725 22.8475 10.7531 22.8475H24.0519C25.1254 22.8475 26.079 22.1623 26.4214 21.1449L30.5783 8.79219Z",
    stroke: "#F1C555",
    strokeWidth: 1.10345
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5783 8.79219C31.0367 7.43008 32.9633 7.43009 33.4217 8.79219L37.5786 21.1449C37.921 22.1623 38.8746 22.8475 39.9481 22.8475H53.2469C54.7127 22.8475 55.3083 24.7337 54.1084 25.5755L43.4715 33.0372C42.5644 33.6735 42.1843 34.831 42.5378 35.8812L46.6289 48.0384C47.0909 49.4111 45.5316 50.5766 44.3459 49.7448L33.4357 42.0914C32.574 41.4869 31.426 41.4869 30.5643 42.0914L19.6541 49.7448C18.4684 50.5766 16.9091 49.4111 17.3711 48.0384L21.4622 35.8812C21.8157 34.831 21.4356 33.6735 20.5285 33.0372L9.89163 25.5755C8.69165 24.7337 9.28725 22.8475 10.7531 22.8475H24.0519C25.1254 22.8475 26.079 22.1623 26.4214 21.1449L30.5783 8.79219Z",
    stroke: "#F1C555",
    fill: "#F1C555"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1224_5835",
    x: 0.747037,
    y: 1,
    width: 76.5059,
    height: 73.3865,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.72414,
    result: "effect1_foregroundBlur_1224_5835"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default __webpack_public_path__ + "static/media/star-full.872c2e878a195381ddae41505cf90741.svg";
export { ForwardRef as ReactComponent };